import { render, staticRenderFns } from "./SupplierLastestBuy.vue?vue&type=template&id=2a6ec17f&scoped=true&"
import script from "./SupplierLastestBuy.vue?vue&type=script&lang=js&"
export * from "./SupplierLastestBuy.vue?vue&type=script&lang=js&"
import style0 from "./SupplierLastestBuy.vue?vue&type=style&index=0&id=2a6ec17f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6ec17f",
  null
  
)

export default component.exports